import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserDetailsComponent} from './user-details/user-details.component';
import {MatLegacyButtonModule as MatButtonModule} from "@angular/material/legacy-button";
import {PublicationDebugComponent} from './publication/publication-debug.component';
import {UserLocalizationDebugComponent} from './user-localization/user-localization-debug.component';
import {MatIconModule} from "@angular/material/icon";
import {FuseHighlightModule} from "../../../@fuse/components/highlight";
import {MatLegacyTabsModule as MatTabsModule} from "@angular/material/legacy-tabs";
import {MatLegacyFormFieldModule as MatFormFieldModule} from "@angular/material/legacy-form-field";
import {MatLegacyInputModule as MatInputModule} from "@angular/material/legacy-input";
import {ReactiveFormsModule} from "@angular/forms";
import {MatLegacySelectModule as MatSelectModule} from "@angular/material/legacy-select";
import { UrlEntryComponent } from './url-entry/url-entry.component';
import { TranslocoModule } from '@ngneat/transloco';
import { EventsComponent } from './events/events.component'
import {ExtProfileDirective} from "../landing-publication/ext-profiles/types/extProfile.directive";

@NgModule({
    declarations: [
        UserDetailsComponent,
        PublicationDebugComponent,
        UserLocalizationDebugComponent,
        UrlEntryComponent,
        EventsComponent
    ],
    exports: [
        UserDetailsComponent,
        PublicationDebugComponent,
        UserLocalizationDebugComponent,
        UrlEntryComponent,
        EventsComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        FuseHighlightModule,
        MatTabsModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatSelectModule,
        TranslocoModule,
        ExtProfileDirective,
    ]
})
export class DebugPanelsModule {
}
